<div dropdown placement="bottom right" class="position-relative">
  <button
    id="header-btn-menu"
    type="button"
    data-bs-toggle="collapse"
    aria-controls="mobileNav"
    dropdownToggle
    aria-label="Toggle navigation">
    <div class="d-flex align-items-center flex-column text-primary">
      <fa-icon [icon]="faBars" class="fs-1 mb-2"></fa-icon>
      <span [style.font-size.px]="18">MENU</span>
    </div>
  </button>

  <ul
    id="header-dropdown-mobile"
    *dropdownMenu
    class="dropdown-menu dropdown-menu-right"
    role="menu"
    aria-labelledby="button-basic">
    <li id="menu-mobile" class="dropdown-item nav-item item-header">Menu</li>
    <ng-container *ngFor="let item of menu; let i = index">
      <ng-container *ngIf="item?.submenus; else menuItemTemplate">
        <li
          [id]="'menu-mobile-' + i"
          class="dropdown-item nav-item item-header">
          {{ item.title }}
        </li>

        <ng-container *ngFor="let submenu of item.submenus; let idx = index">
          <li class="dropdown-item nav-item">
            <a
              [id]="'submenu-item-' + idx"
              class="item-link text-decoration-none"
              aria-current="page"
              (click)="redirectTo(submenu)"
              (keyup.enter)="redirectTo(submenu)"
              [attr.tabindex]="0"
              >{{ submenu.title }}

              <fa-icon [icon]="faChevronRight" class="fs-5"></fa-icon>
            </a>
          </li>
        </ng-container>
      </ng-container>

      <ng-template #menuItemTemplate>
        <li class="dropdown-item nav-item">
          <a
            [id]="'menu-mobile-' + i"
            class="item-link text-decoration-none"
            aria-current="page"
            (click)="redirectTo(item)"
            (keyup.enter)="redirectTo(item)"
            [attr.tabindex]="0">
            <div>
              {{ item.title }}
              @if (item?.additionalTitle) {
                <span class="text-capitalize">
                  {{ item.additionalTitle }}
                </span>
              }
            </div>
            <fa-icon [icon]="faChevronRight" class="fs-5"></fa-icon>
          </a>
        </li>
      </ng-template>
    </ng-container>

    <li id="menu-mobile-acesso" class="dropdown-item nav-item item-header">
      <span class="bi bi-person-fill mr-1"></span>
      <ng-container *ngIf="userInfo?.isLoggedIn; else genericAccessTemplate">
        Olá {{ userInfo.userFirstName ?? '' }}!
      </ng-container>
    </li>

    <ng-container *ngFor="let menuItem of userMenu">
      <li class="dropdown-item nav-item">
        <a
          id="menu-mobile-resultados"
          [routerLink]="[menuItem.url]"
          class="item-link text-decoration-none"
          aria-current="page"
          href="#"
          >{{ menuItem.title }}

          <fa-icon [icon]="faChevronRight" class="fs-5"></fa-icon>
        </a>
      </li>
    </ng-container>

    <li class="dropdown-item-menu d-flex justify-content-around text-white">
      <ng-container *ngIf="!userInfo?.isLoggedIn; else signOutTemplate">
        <button
          id="menu-mobile-signin"
          class="btn btn-outline-light px-4"
          [routerLink]="['/login.html']">
          Entrar
        </button>

        <button
          id="menu-mobile-signup"
          class="btn btn-link text-white"
          aria-current="page"
          [routerLink]="['/cadastro/dados-pessoais.html']">
          Cadastrar
        </button>
      </ng-container>
    </li>
  </ul>
</div>

<ng-template #genericAccessTemplate> Meu acesso</ng-template>

<ng-template #signOutTemplate>
  <button
    id="menu-mobile-signin"
    class="btn btn-outline-light px-4"
    (click)="onLogout()">
    sair
  </button>
</ng-template>
